import { SET_USERS, SET_LOADING, SET_ERROR, SET_USER, SET_USER_ROLE, SET_USER_ID } from './actions';

const initialState = {
  users: [],
  loading: false,
  error: '',
  userId: parseInt(sessionStorage.getItem('userId')) || '',
  userName: sessionStorage.getItem('name') || '',
  userRole: parseInt(sessionStorage.getItem('userRole')) || '',
};

export const globalReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return { ...state, loading: action.payload };
    case SET_USERS:
      return { ...state, users: action.payload, error: '', loading: false };
    case SET_ERROR:
      return { ...state, error: action.payload, loading: false };
    case SET_USER:
      return { ...state, userName: action.payload };
    case SET_USER_ID:
      return { ...state, userId: action.payload };
    case SET_USER_ROLE:
      return { ...state, userRole: action.payload };
    default:
      return state;
  }
};
